import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {BarChartModel} from '../../../../../models/questions/subModels/barChart.model';
import {DropdownModel} from '../../../../../models/component/dropdown.model';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-bar-chart',
  templateUrl: './evo-bar-chart.component.html',
  styleUrls: ['./evo-bar-chart.component.css']
})
export class EvoBarChartComponent implements OnInit {

  BarChartModel = BarChartModel;

  @Input() question: QuestionModel = new BarChartModel();

  constructor() { }

  ngOnInit() {
  }

  castedQuestion(): BarChartModel {
    return <BarChartModel>this.question;
  }

  getInterpretationTypes(): DropdownModel[] {

    if (this.castedQuestion().answerType === Enums.AnswerTypes.input) {
      return [
        DropdownModel.generateFromKey(BarChartModel.InterpretationTypes.none)
      ];
    }

    return [
      DropdownModel.generateFromKey(BarChartModel.InterpretationTypes.min),
      DropdownModel.generateFromKey(BarChartModel.InterpretationTypes.max)
    ];

  }

  setNumBarSeparators(separators: string) {

    this.castedQuestion().model.numBarSeparators = parseInt(separators, 10);

    this.castedQuestion().model.firstRange.min = 0;

    if (this.castedQuestion().model.numBarSeparators === 10) {
      this.castedQuestion().model.firstRange.max = 10;
    } else if (this.castedQuestion().model.numBarSeparators === 5) {
      this.castedQuestion().model.firstRange.max = 5;
    }

  }

  showQuestion(): boolean {

    if (this.question) {
      if (this.question.subCategory === Enums.QuestionSubcategories.barChart) {
        return true;
      }
    }

    return false;

  }

}
